export default [
  { valor: 7, nome: 'ampola(s)' },
  { valor: 5, nome: 'capsula(s)' },
  { valor: 12, nome: 'colher(es)' },
  { valor: 1, nome: 'comprimido(s)' },
  { valor: 6, nome: 'frasco(s)' },
  { valor: 2, nome: 'gota(s)' },
  { valor: 11, nome: 'grama(s)' },
  { valor: 9, nome: 'jato(s)' },
  { valor: 14, nome: 'litro(s)' },
  { valor: 13, nome: 'mg(s)' },
  { valor: 3, nome: 'ml(s)' },
  { valor: 10, nome: 'puff(s)' },
  { valor: 8, nome: 'sachê(s)' },
  { valor: 4, nome: 'unidade(s)' },
  { valor: 15, nome: 'UI(s)' },
  { valor: 16, nome: 'Adesivo(s)' }
];

// próximo valor: 17
